import { render } from "./Results.vue?vue&type=template&id=2d1e59d7"
import script from "./Results.vue?vue&type=script&lang=js"
export * from "./Results.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/v-lexma/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])